<template>
    <div>
        <div class='campus-bg'>
            <el-image :src="campus_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <el-image :src="campus_title" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class='home_content'>
                <div class='home_title'>
                    <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  style="height: 4.5vw;">
                    <p>{{$t('home.bole_we')}}</p>
                </div>
                <div class="video_content">
                    <div class="video">
                        <video v-if="is_mobile_video" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/job_video.mp4" preload="none"
                               controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_2.jpg"> </video>
                        <video v-else src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/job_video.mp4"  preload="none"
                               controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_2.jpg"> </video>
                    </div>
                </div>
            </div>
            <div class='campus-list'>
                <div class="campus-item">
                    <el-image :src="campus_welfare" class="campus-img"></el-image>
                </div>
                <div class="campus-item-job">
                    <el-row :gutter="0" style="margin-top: 10%">
                        <el-col v-for="job in job_list" :span="8" :key="job.name">
                            <router-link :to="'/join_campus_details?job_name='+job.name" style="position:relative;">
                                <el-image :src="'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/'+ job.name +'.png'" style="margin: 4% 0; position: relative;">
                                </el-image>
                            </router-link>
                        </el-col>
                    </el-row>
                </div>
                <div class="campus-item">
                    <el-image :src="campus_up" class="campus-img"></el-image>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            campus_header: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_header.jpg',
            campus_title: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_title.png',
            campus_welfare: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_welfare.png',
            campus_up: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_up.png',
            job_list: [],
        }
    },
    created() {
        this.getJson();
    },
    methods: {
        getJson() {
            const json = require('../assets/json/campus_job.json');
            const data = Object.keys(json);
            this.job_list = data.map((item) => {
                return { name: item };
            })
        }
    },
    computed: {
      //是否使用移动端视频
      is_mobile_video() {
        return document.documentElement.clientWidth > 992;
      },
    },
}
</script>

<style>

.campus-item, .campus-item-job {
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.campus-item {
    width: 90%;
}
.campus-item-job {
    width: 60%;
}
.campus-img{
    width: 100%;
}
@media screen and (max-width: 992px) {
    .campus-item {
        width: 120%;
        position: relative;
        right: 10%;
    }
    .campus-item, .campus-item-job {
        margin-top: 20px;
    }
    .campus-item-job {
        width: 80%;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/JoinUsCampus.vue